import { WebsiteWithStaticData } from '../../types/types';
import TableActionRow, { TableActionRowProps } from '../TableActionRow/TableActionRow';
import Tooltip from '../Tooltip/Tooltip';

import styles from './WebsitesInfo.module.scss';

interface WebsitesInfoProps extends TableActionRowProps {
  data: WebsiteWithStaticData[];
  rowHeaderRenderer: React.FC<WebsiteWithStaticData>;
  renderers: React.FC<WebsiteWithStaticData>[];
  actionRenderer: React.FC<WebsiteWithStaticData>;
}

export const WebsitesInfo = ({
  data,
  rowHeaderRenderer,
  renderers,
  actionRenderer,
  ...tableActionRowProps
}: WebsitesInfoProps) => {
  return (
    <div>
      <div className={styles.headerWrapper}>
        <TableActionRow placeholder="Website name or URL" {...tableActionRowProps} />
        <div className={styles.tableHeader}>
          <div>website name</div>
          <div key={0}>
              <Tooltip>We monitor the HTTP STATUS CODE. This indicates what a website thinks about its own health. Well-known status codes include 200 OK, 404 Not Found and 500 Internal Server Error.</Tooltip>
              <div>STATUS CODE</div>
            </div>
            <div key={1}>
              <Tooltip>We monitor the content of the website. We are looking for specific keywords that you tell us. For example, we can check if the website text contains the word "Hacked", or if it doesn't contain "Healthy".</Tooltip>
              <div>CONTENT</div>
            </div>
            <div key={2}>
              <Tooltip>We monitor how fast the websites are. We measure how much time it would take for a user's browser to load the website after the user clicks a link pointing to it.</Tooltip>
              <div>SPEED</div>
            </div>
            <div key={3}>
              <Tooltip>We monitor if the SSL certificates are valid. We check if they exist and when they expire.</Tooltip>
              <div>SSL CERTIFICATE</div>
            </div>
        </div>
      </div>
      <div className={styles.container}>
        {data.map((item) => (
          <div key={item.id} className={styles.infoRow}>
            <div className={styles.title}>{rowHeaderRenderer(item)}</div>
            <div className={styles.statuses}>
              {renderers.map((renderer, i) => (
                <div key={i}>{renderer(item)}</div>
              ))}
            </div>
            <div className={styles.rowActions}>{actionRenderer(item)}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
